/**
 * Constant settings for the search component.
 * @module constants/SearchSettings
 */
export const SEARCH_CONSTANTS = {
  categoriasFiltro: [],
  orgaosFiltro: [],
  gruposTipos: {
    Midia: [
      {
        descricao: 'Arquivo',
        tipos: ['File'],
      },
      {
        descricao: 'Áudio',
        tipos: [],
      },
      {
        descricao: 'Conteúdo Externo',
        tipos: ['Link'],
      },
      {
        descricao: 'Imagem',
        tipos: ['Image'],
      },
      {
        descricao: 'Multimídia',
        tipos: [],
      },
    ],
  },
  categorias: [
    {
      descricao: 'Serviços',
      tipos: ['Servico', 'Tema'],
      idAba: 'servicos',
    },
    {
      descricao: 'Serviços Estaduais',
      tipos: ['ServicoEstadual'],
      idAba: 'servicos_estaduais',
    },
    {
      descricao: 'Notícias',
      tipos: ['News Item', 'collective.nitf.content'],
      idAba: 'noticias',
    },
    {
      descricao: 'Sites',
      tipos: ['Site'],
      idAba: 'sites',
    },
    {
      descricao: 'Apps',
      tipos: ['App'],
      idAba: 'apps',
    },
    {
      descricao: 'Todos',
      tipos: [
        'ServicoEstadual',
        'collective.nitf.content',
        'App',
        'Campanha',
        'Servico',
        'Site',
        'Document',
        'sc.embedder',
        'News Item',
        'File',
        'Tema',
        'Link',
        'Audio',
        'Image',
        'ExternalContent',
      ],
      idAba: 'todos',
    },
  ],
  ordenacao: '-relevancia',
  tamanhoPagina: 30,
};
